import React, { memo, forwardRef } from "react";
const SvgSigma = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.784 22.656c-1.152 0-2.168-.24-3.048-.72-.864-.496-1.536-1.216-2.016-2.16-.48-.96-.72-2.128-.72-3.504 0-1.616.28-2.912.84-3.888a4.943 4.943 0 012.376-2.16c1.024-.448 2.232-.672 3.624-.672h4.992a.816.816 0 110 1.632H19.72c.416.384.76.824 1.032 1.32a6.02 6.02 0 01.648 1.68c.16.624.24 1.32.24 2.088 0 .864-.128 1.688-.384 2.472a5.863 5.863 0 01-1.104 2.04 5.077 5.077 0 01-1.824 1.368c-.736.336-1.584.504-2.544.504zm.048-1.752c.864 0 1.568-.208 2.112-.624.544-.416.944-.968 1.2-1.656a6.695 6.695 0 00.384-2.304c0-.688-.072-1.336-.216-1.944a6.728 6.728 0 00-.6-1.704 7.089 7.089 0 00-1.032-1.488h-.84c-1.04 0-1.912.176-2.616.528-.704.336-1.232.88-1.584 1.632-.336.736-.504 1.712-.504 2.928 0 .896.128 1.696.384 2.4s.656 1.256 1.2 1.656c.544.384 1.248.576 2.112.576z"
      />
    </svg>
  );
});
SvgSigma.displayName = "SvgSigma";
const MemoForwardRef = memo(SvgSigma);
export default MemoForwardRef;
